module.exports = __webpack_public_path__ + "media/pricing/EGiftCardProduct-765df49d.png";